'use strict';

const classNames = {
	mobileNav: 'mobile-primary-nav',
	link: 'item__link',
	subNav: 'sub-nav'
};

const modifierNames = {
	hasSubMenu: 'has-sub-menu',
	active: 'active'
}

function setupSubMenus() {
	$.findByBem(classNames.mobileNav, classNames.link, modifierNames.hasSubMenu).on('click.primaryNav', function (e) {
		const link = $(this);
		const active = link.parent().hasBemClass(classNames.mobileNav, classNames.link, modifierNames.active);
		if (link.prop('href') === '#' || !active) {
			e.preventDefault();
			if (active) {
				link.parent().trigger('collapse');
			} else {
				link.parent().siblings().trigger('collapse');
				link.parent().trigger('expand');
			}
		}
	}).parent().on('expand.primaryNav', function () {
		$(this)
			.addBemClass(classNames.mobileNav, classNames.link, modifierNames.active)
			.childrenByBem(classNames.mobileNav, classNames.subNav).slideDown();
	}).on('collapse.primaryNav', function () {
		$(this)
			.removeBemClass(classNames.mobileNav, classNames.link, modifierNames.active)
			.childrenByBem(classNames.mobileNav, classNames.subNav).slideUp();
	});
}

export default {
	init: function () {
		setupSubMenus();
	}
}